export default __webpack_public_path__ + "static/media/q.a1bef8d3.svg";